export default __webpack_public_path__ + "static/media/Tesla-Mask.81954d18.png";